<div [ngClass]="publisherType == publisherTypeEn.AudioTranslate ? 'audio' : 'video'" [ngStyle]="{ 'opacity': opacity }" #publisherDiv></div>
